<script>
    import Select from '$lib/components/UI/Select32.svelte';
    import { sortBy } from '$lib/utils'
    import { DynamicDict } from '$lib/stores/dynamicDict'
    export let marca = ''
    export let modelo = ''
    export let medida = ''
    export let descripcion = ''
    export let dict = new DynamicDict('Licitacion - Atributos Neumaticos')
    export let valid = true
    
    let bindOptions = {
        marca: null,
        modelo: null,
        medida: null,
    }
    const toOptions = (dict) => {
        return sortBy(Object
            .entries(dict)
            .map(([label, value]) => ({label, value})),
            ['label']
        ).reverse()
    }
    const getLabel = (value, options) => {
        return options.find(x => x.value === value)?.label || ''
    }
    $: modelos = dict.sub(marca)
    $: modidas = modelos.sub(modelo)
    $: marcasOpt = toOptions($dict.data || {})
    $: modelosOpt = toOptions($modelos.data || {})
    $: medidasOpt = toOptions($modidas.data || {})
    $: if (marcasOpt || modelosOpt || medidasOpt) {
        descripcion = `${getLabel(marca, marcasOpt)}; ${getLabel(modelo, modelosOpt)}; ${getLabel(medida, medidasOpt)}`
    }
    $: console.log({
        values: {marca, modelo, medida},
        options: {marcasOpt, modelosOpt, medidasOpt},
        bindOptions
    })
    $: valid = Object.values(bindOptions).every(e => ![null, undefined].includes(e))
</script>

<Select bind:option={bindOptions.marca} bind:value={marca} options={marcasOpt} placeholder="Selecciona una marca" label="Marca"/>
<Select bind:option={bindOptions.modelo} bind:value={modelo} options={modelosOpt} placeholder="Selecciona un modelo" label="Modelo"/>
<Select bind:option={bindOptions.medida} bind:value={medida} options={medidasOpt} placeholder="Selecciona una medida" label="Medida"/>


